import PersonalProfilePhoto from "components/PersonalProfilePhoto";
import Radio from "components/Radio";
import TruncateText from "components/TruncateText";

import { useTranslationContext } from "context/TranslationContext";
import cn from "lib/cn";

import { EAccount } from "types/index";

interface MemberItemRadioProps {
  selectedId?: string;
  id: string;
  name: string;
  accountType: EAccount;
  profilePicture: string;
  className?: string;
  onSelectMember?: (value: string) => void;
}

const MemberItemRadio = ({
  id,
  name,
  accountType,
  profilePicture,
  className,
  selectedId,
  onSelectMember,
}: MemberItemRadioProps) => {
  const { t } = useTranslationContext();
  return (
    <div
      key={id}
      className={cn(
        "w-full flex items-center justify-between gap-2 py-4 border-b-[0.125rem] border-line-500",
        className
      )}
    >
      <div className="flex items-center gap-3">
        <div>
          <PersonalProfilePhoto
            type={accountType}
            imageUrl={profilePicture}
            label={name}
            width={48}
            height={48}
          />
        </div>
        <div className="text-left">
          <div className="font-medium text-lg">
            <TruncateText id={id} text={name} tooltipWidth={250} />
          </div>
          <div className="text-gray-900">
            <TruncateText
              id={`id-${id}`}
              text={`${t("id")}: ${id.toUpperCase()}`}
              tooltipWidth={250}
            />
          </div>
        </div>
      </div>
      <Radio
        value={id}
        isSelected={id === selectedId}
        circleSize={18}
        onClick={onSelectMember}
      />
    </div>
  );
};

export default MemberItemRadio;
